import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash.clonedeep'
import UAParser from 'ua-parser-js'
import donateApi from './api/donate'

Vue.use(Vuex)

const state = {
  step: 'form',
  form: 'light',
  page: 'form',
  language: 'ru',
  header: true,
  footer: true,
  terms: 'https://donate.ovdinfo.legal/js/widget/oferta.pdf',
  termsEn: ['https://donate.ovdinfo.legal/js/widget/oferta-2024.pdf', 'https://en.ovdinfo.org/privacy-donate'],
  reports: 'https://donate.ovdinfo.legal/',
  currencies: {
    RUB: {
      scale: [5000, 3000, 900, 700, 400],
      min: 1,
      symbol: 'Р',
      symbol_en: 'RUB'
    },
    EUR: {
      scale: [100, 50, 40, 25, 10],
      scale_en: [90, 40, 15],
      min: 1,
      symbol: '€',
      symbol_en: 'EUR'
    },
    USD: {
      scale: [100, 50, 40, 25, 10],
      scale_en: [90, 40, 15],
      min: 1,
      symbol: '$',
      symbol_en: 'USD'
    }
  },
  operators: {
    'cp-cards': {
      name: 'Банковские карты',
      currencies: ['RUB'],
      img: 'card_logos.png',
      align: 'right',
      month: true,
      published: true
    },
    'stripe': {
      name: 'Банковские карты',
      currencies: ['EUR', 'USD'],
      img: 'cards.png',
      align: 'right',
      month: true,
      published: true
    },
    // 'ym-cards': {
    //   name: 'Банковские карты',
    //   currencies: ['RUB'],
    //   img: 'card_logos.png',
    //   align: 'right',
    //   month: true,
    //   published: false
    // },
    // 'ym-ym': {
    //   name: 'ЮMoney',
    //   currencies: ['RUB'],
    //   img: 'iomoney.png',
    //   month: false,
    //   published: false
    // },
    // 'ym-gp': {
    //   name: 'Наличные (через терминал)',
    //   currencies: ['RUB'],
    //   img: 'cash.png',
    //   month: false,
    //   published: false
    // },
    // 'pp-gg': {
    //   name: 'PayPal',
    //   currencies: ['RUB', 'EUR'],
    //   img: 'paypal.png',
    //   icon: 'global-giving.png',
    //   url: 'https://donate.ovdinfo.legal/interim.html',
    //   description: 'Мы принимаем разовые пожертвования через PayPal на портале GlobalGiving',
    //   label: 'Перейти на GlobalGiving',
    //   month: true,
    //   published: true
    // },
    'btc-eth': {
      name: 'BTC/ETH',
      currencies: ['RUB', 'EUR'],
      img: 'btc.png',
      icon: 'crypto.png',
      url: 'https://donate.ovdinfo.legal/crypto',
      description: 'Мы принимаем разовые пожертвования в 8 видах криптовалюты',
      label: 'Поддержать криптой',
      month: false,
      published: true
    },
    'zaodno': {
      name: 'Zaodno',
      currencies: ['RUB', 'EUR'],
      img: 'zaodno.svg',
      icon: 'zaodno-cards.png',
      url: 'https://zaodno.org/ovd-info?utm_source=oi&utm_medium=button&utm_campaign=oi_payment_form',
      description: 'Помочь задержанным оплатить защитников напрямую можно на платформе «Заодно»',
      label: 'Помочь задержанным',
      month: false,
      published: true
    },
    'intl-cards': {
      icon: 'zaodno-cards.png',
      url: 'https://donate.ovdinfo.legal/'
    }
  },
  checkoutUrl: '',
  checkoutMsg: '',
  checkoutParams: {},
  checkoutType: 'redirect',
  donation: {
    sum: 700,
    month: true,
    mode: 'monthly',
    currency: 'RUB',
    email: '',
    method: 'cp-cards',
    source: '',
    mobile: false,
    page_source: '',
    firstname: '',
    lastname: '',
    middlename: '',
    address: '',
    city: '',
    country: '',
    zip: '',
    phone: '',
    project: 0,
    extra_rate: 0,
    comment: 'Благотворительное пожертвование',
    data: {},
    version: {}
  },
  internalDonationId: '',
  unsubscribeReason: '',
  oldSum: '',
  newSum: ''
}

const defaultFormValues = {
  'inside': {
    form: 'light',
    donation: {
      sum: 700,
      month: true,
      mode: 'monthly',
      currency: 'RUB',
      method: 'cp-cards'
    }
  },
  'outside': {
    form: 'light-external',
    donation: {
      sum: 25,
      month: true,
      mode: 'monthly',
      currency: 'EUR',
      method: 'stripe'
    }
  }
}

const mutations = {
  updateDonation (state, change) {
    state.donation[change.prop] = change.value
  },
  updateState (state, change) {
    Object.keys(change).forEach(prop => {
      const value = change[prop]
      if (typeof value === 'object') {
        Object.keys(value).forEach(nestedProp => {
          state[prop][nestedProp] = value[nestedProp]
        })
      } else {
        state[prop] = value
      }
    })
    // console.info('STATE', state)
  },
  setStep (state, step) {
    state.step = step
  },
  setPage (state, page) {
    state.page = page
  },
  parseUTMData (state) {
    const utmData = window.oi_utm || {}
    let clientData = Object.assign({}, state.donation.data)
    if (utmData.utm_source) {
      clientData.utm_source = utmData.utm_source
    }
    if (utmData.utm_medium) {
      clientData.utm_medium = utmData.utm_medium
    }
    if (utmData.utm_campaign) {
      clientData.utm_campaign = utmData.utm_campaign
    }
    if (utmData.utm_term) {
      clientData.utm_term = utmData.utm_term
    }
    if (utmData.utm_content) {
      clientData.utm_content = utmData.utm_content
    }

    state.donation.data = clientData
  }
}

const actions = {
  showStep ({ commit }, step) {
    commit('setStep', step)
  },
  showPage ({ commit }, page) {
    commit('setPage', page)
  },
  switchLanguage ({ commit }, lang) {
    commit('updateState', { language: lang })
  },
  resetForm ({ commit }) {
    commit('setStep', 'form')
    commit('updateState', {
      checkoutUrl: '',
      checkoutMsg: '',
      checkoutParams: {},
      checkoutType: 'redirect'
    })
  },
  changeMethod ({ commit, state }, value) {
    const change = {}
    const operator = state.operators[value]
    const month = state.donation.month

    change.method = value
    if (month && !operator.month) {
      change.month = false
      change.mode = change.month ? 'monthly' : 'one-off'
    }

    const update = {
      donation: change
    }
    commit('updateState', update)
  },
  changeMonth ({ commit, state }, value) {
    const mode = value ? 'monthly' : 'one-off'
    const change = {
      month: value,
      mode
    }
    const methodId = state.donation.method
    const operator = state.operators[methodId]

    if (!operator.month && value) {
      const newMethodId = Object.keys(state.operators).find(opId => state.operators[opId].month === value)
      change['method'] = newMethodId
    }

    let update = {
      donation: change,
      step: 'form'
    }

    commit('updateState', update)
  },
  changeCurrency ({ commit }, value) {
    const change = {
      currency: value
    }

    let update = {
      donation: change,
      step: 'form'
    }

    commit('updateState', update)
  },
  changeMode ({ commit }, value) {
    let update

    if (typeof value === 'object') {
      update = {
        donation: {
          mode: value.mode,
          month: value.mode === 'monthly'
        },
        step: value.step || 'form'
      }
    } else {
      update = {
        donation: {
          mode: value,
          month: value === 'monthly'
        },
        step: 'form'
      }
    }

    commit('updateState', update)
  },
  changeExtraRate ({ commit }, value) {
    const change = {
      extra_rate: value
    }

    let update = {
      donation: change
    }

    commit('updateState', update)
  },
  switchCountryForm ({ commit }, formId) {
    const update = defaultFormValues[formId]
    if (update) commit('updateState', update)
  },
  parseQueryString ({ commit, state }, queryString) {
    const donation = state.donation
    const change = {}
    const update = {}
    for (let key in queryString) {
      if (donation.hasOwnProperty(key)) {
        change[key] = queryString[key]
        if (key === 'sum') {
          change['sum'] = parseInt(queryString['sum'])
        }
        if (key === 'month') {
          change['month'] = queryString['month'] === 'true'
        }
      }
      if (key === 'from') {
        update['oldSum'] = parseInt(queryString['from'])
      }
      if (key === 'step') {
        update['step'] = queryString['step']
      }
    }

    update.donation = change

    commit('updateState', update)
  },
  setConfiguration ({ commit, state }, config) {
    let update = {}

    for (let key in config) {
      if (state.hasOwnProperty(key)) {
        update[key] = config[key]
      }
    }

    commit('updateState', update)
  },
  setClientData ({ commit, state }) {
    const clientParser = new UAParser()
    const utmData = window.oi_utm || {}
    let clientData = {
      client: clientParser.getResult(),
      device: clientParser.getDevice().type || 'desktop',
      url: window.location.protocol + '//' + window.location.host + window.location.pathname,
      form: state.form
    }
    const deviceUUID = _getCookie('mindboxDeviceUUID')
    if (utmData.utm_source) {
      clientData.utm_source = utmData.utm_source
    }
    if (utmData.utm_medium) {
      clientData.utm_medium = utmData.utm_medium
    }
    if (utmData.utm_campaign) {
      clientData.utm_campaign = utmData.utm_campaign
    }
    if (deviceUUID) {
      clientData.deviceUUID = deviceUUID
    }
    if (utmData.utm_term) {
      clientData.utm_term = utmData.utm_term
    }
    if (utmData.utm_content) {
      clientData.utm_content = utmData.utm_content
    }

    const update = {
      donation: {
        mobile: clientParser.getDevice().type === 'mobile',
        data: clientData
      }
    }

    commit('updateState', update)
  },
  donate ({ commit, state }) {
    commit('parseUTMData')
    commit('setStep', 'precheckout')
    donateApi.donate(state.donation, (err, res) => {
      if (err) {
        commit('setStep', 'form')
      } else {
        let update = {
          checkoutMsg: res.message,
          checkoutUrl: res.url,
          checkoutParams: res.payment,
          step: 'checkout'
        }
        if (res.payment) {
          update.internalDonationId = res.payment.donationId
        }
        if (res.popup) {
          update.checkoutType = 'popup'
        } else if (res.widget) {
          update.checkoutType = 'widget'
        } else if (res.iframe) {
          update.checkoutType = 'iframe'
        } else {
          update.checkoutType = 'redirect'
        }
        commit('updateState', update)
      }
    })
  },
  unsubscribe ({ commit, state }) {
    donateApi.unsubscribe(state.donation.email, state.unsubscribeReason, (err, res) => {
      if (err) {
        commit('updateState', { step: 'unsubscribe-error' })
      } else {
        commit('updateState', { step: 'confirmation' })
      }
    })
  },
  changeSubscription ({ commit, state }) {
    donateApi.changeSubscription(state.donation.email, state.oldSum, state.newSum, (err, res) => {
      if (err) {
        commit('updateState', { step: 'unsubscribe-error' })
      } else {
        commit('updateState', { step: 'confirmation' })
      }
    })
  }
}

const _getCookie = name => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

export default {
  createStore () {
    const store = {
      state,
      actions,
      mutations
    }
    return new Vuex.Store(cloneDeep(store))
  }
}
